<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><span>Cast of Characters</span></p>
<p class="center1"><span>AND THE PAGES ON WHICH THEY FIRST APPEAR</span></p>
<p class="hang-indent">Patience Thumm, <i>Inspector Thumm’s daughter, and the narrator; a sophisticated young woman with a flair for detection</i></p>
<p class="hang-indent">Inspector Thumm, <i>ex-inspector in charge of homicide of the New York police: now an inquiry agent</i></p>
<p class="hang-indent">Elihu Clay, <i>a contractor in Leeds, Tilden County, who claimed to be more sinned against than sinning</i></p>
<p class="hang-indent">Walter Bruno, <i>Governor of the state, erstwhile District Attorney of New York County, friend of Inspector Thumm, and</i></p>
<p class="hang-indent">Drury Lane, <i>celebrated Shakespearean actor (now retired) whose brilliant feats of detection have been recorded in</i> The Tragedy of X <i>and</i> The Tragedy of Y</p>
<p class="hang-indent">Joel Fawcett, <i>State Senator and grafter extraordinary, more surprised than anyone by his murder</i></p>
<p class="hang-indent">Dr. Ira Fawcett, <i>Joel’s brother and Elihu Clay’s partner, whose depature from this life was as sudden, as dramatic, and as deserved as his brother’s</i></p>
<p class="hang-indent">Jeremy Clay, <i>Elihu Clay’s son, in love with Patience</i></p>
<p class="hang-indent">District Attorney John Hume, <i>a shining knight in not-so-white armor</i></p>
<p class="hang-indent">Dr. Bull, <i>Coroner and Police Doctor</i></p>
<p class="hang-indent">Chief Kenyon, <i>Chief of Police in Leeds; the perfect picture of a heel</i></p>
<p class="hang-indent">Carmichael, <i>Joel Fawcett’s secretary</i>—<i>who was other things besides</i></p>
<p class="hang-indent">Rufus Cotton, a <i>political boss, who determined that nothing should interfere with John Hume’s political future</i></p>
<p class="hang-indent">Fanny Kaiser, <i>who made a good thing out of vice, thanks to the protection of the Fawcett brothers</i></p>
<p class="hang-indent">Warden Magnus, <i>Warden of Algonquin prison at Leeds. His was the responsibility for Aaron Dow, and his was the failure</i></p>
<p class="hang-indent">Father Muir, <i>Chaplain at Algonquin prison. The world was too much with him</i></p>
<p class="hang-indent">Aaron Dow, <i>twice convicted of murder, and twice released</i></p>
<p class="hang-indent">Mark Currier, <i>Dow’s lawyer, who would defend the devil for a price</i></p>
<p class="hang-indent">Park Callahan} <i>prison guards who failed in their duty</i></p>
<p class="hang-indent">Tabb, <i>a trusty, assistant librarian at the prison</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?6b5bb7ec